import React from 'react';
import PropTypes from 'prop-types';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import Selection from './Selection';
import Financials from './Financials';

import '../css/animations.css';
import '../css/my-team.css';
import '../css/financials.css';

const MyTeam = props => (
  <div id="my-team">
    <div id="my-team__info">
      <button 
        onClick={props.submitTeam}
        className="my-team__submit">Submit <span>team</span></button>
      <div id="my-team__financials">
        <Financials 
          spent={props.spent}
          remaining={props.remaining}
        />
      </div>
      <TransitionGroup component="div" className="selection-list">
        {Object.keys(props.selectionGroup).map(key => 
          <CSSTransition classNames="selection" key={key} timeout={{enter: 500, exit: 500}}>
            <Selection 
              key={key} 
              index={key}
              details={props.selectionGroup[key]} 
              removePlayer={props.removePlayer}
            />
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
  </div>
)

MyTeam.propTypes = {
  spent: PropTypes.number,
  remaining: PropTypes.number,
  selectionGroup: PropTypes.object,
  removePlayer: PropTypes.func,
  submitTeam: PropTypes.func,
}

export default MyTeam;